var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3918 0.608247C11.7277 0.944173 11.7277 1.48882 11.3918 1.82474L7.21649 6L11.3918 10.1753C11.7277 10.5112 11.7277 11.0558 11.3918 11.3918C11.0558 11.7277 10.5112 11.7277 10.1753 11.3918L6 7.2165L1.82474 11.3918C1.48882 11.7277 0.944173 11.7277 0.608247 11.3918C0.272322 11.0558 0.272322 10.5112 0.608247 10.1753L4.7835 6L0.608247 1.82474C0.272322 1.48882 0.272322 0.944173 0.608247 0.608247C0.944173 0.272322 1.48882 0.272322 1.82474 0.608247L6 4.7835L10.1753 0.608248C10.5112 0.272322 11.0558 0.272322 11.3918 0.608247Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6ba61250877d3e7076090dc5146a1e5c.svg";
export { ForwardRef as ReactComponent };